import {observer} from 'mobx-react-lite';
import Alert from '@src/components/shared/alert/alert';
import {useStores} from '@src/components/store';
import React from 'react';
import useCustomModal from '@src/components/shared/custom-modal/custom-modal';
import usePromiseFeedback from '@src/components/shared/promise-feedback/usePromiseFeedback';
import CustomButton from '@src/components/shared/custom-button/custom-button';

export const InactiveDnsProtectionAlert: React.FC = observer(() => {

    const { fwVersionBronzeStore } = useStores();
    const [showModal, , modalContextHolder] = useCustomModal();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();

    const openActivateModal = () => {
        showModal({
            width: 560,
            title: 'Reactivate DNS Protection',
            body: () => (
                <div className="modal-deactivation-version-message">
                    Your network will resume protection from unsafe and malicious websites.
                </div>
            ),
            okText: 'Reactivate',
            cancelText: 'Cancel',
            onOk: () => {
                promiseFeedbackFactory({
                    // isDeactivate=false => dnsEnabled=true
                    promise: fwVersionBronzeStore.deactivateReactivateDnsProtection(false),
                    notifObj: { show: false },
                    successCallback: () => {
                        // Ensure UI reflects the new version type (DNS_DEACTIVATE -> normal)
                        void fwVersionBronzeStore.loadBronzeVersionData();
                    }
                });
            }
        });
    };

    if (!fwVersionBronzeStore.isDnsProtectionDeactivated) return <></>;

    return (
        <>
            {modalContextHolder}
            {promiseContextHolder}
            <Alert
                header={<>
                    <span>DNS protection is inactive</span>
                    <CustomButton className={'link-btn'} label={'Activate'}
                                  isDisabled={fwVersionBronzeStore.isPendingVersion}
                                  onClick={openActivateModal}/>
                </>}
            />
        </>
    );
});